export default __webpack_public_path__ + "static/media/tnie.e10a4969.jpg";